/* eslint-disable no-unused-vars */
import { nanoid } from 'nanoid'
import SubBubbleAgreementDiscountViewModel from './subBubbleAgreementDiscountViewModel'

export default class SubBubbleAgreementViewModel {
  constructor({
    id = null,
    clientId,
    clientGroupId,
    startDateUtc = null,
    startDateLocal,
    endDateUtc = null,
    endDateLocal,
    deleted = 0,
    discounts = [new SubBubbleAgreementDiscountViewModel({ id: nanoid() })],
  } = {}) {
    /**
     * @type {Number}
     */
    this.id = id
    /**
     * @type {Number}
     */
    this.clientId = clientId
    /**
     * @type {Number}
     */
    this.clientGroupId = clientGroupId
    /**
     * @type {Date}
     */
    this.startDateUtc = startDateUtc
    /**
     * @type {Date}
     */
    this.startDateLocal = startDateLocal
    /**
     * @type {Date}
     */
    this.endDateUtc = endDateUtc
    /**
     * @type {Date}
     */
    this.endDateLocal = endDateLocal
    /**
     * @type {Boolean}
     */
    this.deleted = deleted
    /**
     * @type {SubBubbleAgreementDiscountViewModel[]}
     */
    this.discounts = discounts
  }
}
